import operations from '~/helpers/device-operations';
import { Operation } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';

export class NAC extends Gateway {
    hasOperationImportData = false;
    reconstruction_status?: number;
    protocol_id?: string;
    protocol_list?: string[];
    brand_id?: string;
    operating_mode?: string;
    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;

    get fieldReconstructionStatus() {
        return { key: 'reconstructionStatus', value: this.reconstruction_status };
    }
    get fieldProtocolId() {
        return { key: 'protocolId', value: this.protocol_id };
    }
    get fieldBrandId() {
        return { key: 'brandId', value: this.brand_id };
    }
    get fieldOperatingMode() {
        return { key: 'operatingMode', value: this.operating_mode };
    }
    get fieldProtocolList() {
        if (this.protocol_list && this.protocol_list.length > 1) {
            return { key: 'protocol_list', value: this.protocol_list, type: 'array' };
        }
    }

    getNetworkFields(): FieldObject[] {
        let fields: FieldObject[] = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }

        return fields;
    }

    get deviceOperations(): Operation[]  {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
        ]);
    }

}
